import LoginButton from "../../components/Login/Login"

function LoginPage() {
    return(
        <section className="LoginPage">
            <LoginButton />
        </section>
    )
}

export default LoginPage